import moment from 'moment';
import {
	HOURS_MINUTES_COLON,
	YEAR_MONTH_DAY_DASH,
	HOURS_MINUTES_SECONDS_COLON,
} from 'utils/constants';
import {
	IRound,
	ISurveyRoundPayload,
	ISurveyRoundResponse,
} from 'modules/admin-panel/pages/settings/models';
import { IReminderFrequencyTypes } from 'modules/admin-panel/pages/templates/models';

export const mapRoundResponse = (round: ISurveyRoundResponse): IRound => {
	const {
		sendRespondentCount,
		startDate,
		endDate,
		sendingTime,
		isDailyReminders,
	} = round;

	return {
		...round,
		sendRespondentCount: sendRespondentCount.toString(),
		startDate: moment(startDate),
		endDate: moment(endDate),
		sendingTime: moment(sendingTime, HOURS_MINUTES_SECONDS_COLON),
		remindersFrequency: isDailyReminders
			? IReminderFrequencyTypes.eachDay
			: IReminderFrequencyTypes.eachTwoDays,
	};
};

export const mapRoundToPayload = (
	round: IRound,
	id: string,
): ISurveyRoundPayload => {
	const {
		sendRespondentCount,
		startDate,
		endDate,
		sendingTime,
		remindersFrequency,
	} = round;
	return {
		id,
		...round,
		sendRespondentCount: Number.parseInt(sendRespondentCount || '', 10),
		startDate: startDate?.format(YEAR_MONTH_DAY_DASH),
		endDate: endDate?.format(YEAR_MONTH_DAY_DASH),
		sendingTime: sendingTime?.format(HOURS_MINUTES_COLON),
		isDailyReminders: remindersFrequency === IReminderFrequencyTypes.eachDay,
	};
};
